<p-message [severity]="severity()" [id]="id()" [icon]="icon()" [closable]="closable()">
    <div class="template">
        @let textItems = text();
        @if (textItems) {
            @for (text of textItems; track $index) {
                <p [innerHTML]="text | translate"></p>
            }
        } @else {
            <ng-content></ng-content>
        }
    </div>
</p-message>
